import React, { useState } from 'react';
import { Icon } from '@fikasio/react-ui-components';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import ListToolbar, { viewModeGroupClassName } from 'components/UI/ListToolbar';
import TasksBoard from './TasksBoard';
import TasksList from './TasksList';

const TasksViewer = ({
  actions,
  onAddTask,
  onSelectAllTasks,
  onTaskClick,
  onTaskSelect,
  projectId,
  selectedTasks,
  showViewModeButtons,
  taskDefaults,
  tasks,
}) => {
  const { t } = useTranslation();
  const [viewMode, setViewMode] = useState('LIST');

  let taskView;
  if (viewMode === 'BOARD') {
    taskView = (
      <TasksBoard
        // onAddTask={onAddTask}
        // onTaskClick={onTaskClick}
        // onTaskSelect={onTaskSelect}
        // selectedTasks={selectedTasks}
        tasks={tasks}
      />
    );
  } else if (viewMode === 'LIST') {
    taskView = (
      <TasksList
        onAddTask={onAddTask}
        onSelectAllTasks={onSelectAllTasks}
        onTaskClick={onTaskClick}
        onTaskSelect={onTaskSelect}
        projectId={projectId}
        selectedTasks={selectedTasks}
        taskDefaults={taskDefaults}
        tasks={tasks}
      />
    );
  } else {
    taskView = null;
  }

  return (
    <>
      {
        (showViewModeButtons || actions) && (
          <ListToolbar
            start={showViewModeButtons && (
              <div className={viewModeGroupClassName}>
                <Button
                  active={viewMode === 'LIST'}
                  aria-label={t('listView')}
                  aria-pressed={viewMode === 'LIST'}
                  onClick={() => setViewMode('LIST')}
                  variant="outline-secondary"
                >
                  <Icon name="list" size="1x" />
                </Button>
                <Button
                  active={viewMode === 'BOARD'}
                  aria-label={t('cardsView')}
                  aria-pressed={viewMode === 'BOARD'}
                  onClick={() => setViewMode('BOARD')}
                  variant="outline-secondary"
                >
                  <Icon name="th" size="1x" />
                </Button>
              </div>
            )}
          >
            {actions}
          </ListToolbar>
        )
      }
      { tasks && taskView }
    </>
  );
};

export default TasksViewer;
